<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span v-if="khdetail.customer_name">{{khdetail.customer_name}}</span>
                    <span v-else>--</span>
                    <div>未跟进</div>
                </div>

                <div class="back-btn">
                    <a-button @click="back">返回</a-button>
                    <a-button-group>
                        <a-button @click="prev" icon="left" />
                        <a-button @click="next" icon="right" />
                    </a-button-group>
                </div>

                <div class="fieldContainer">
                    <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="khdetail.mobile_phone"><a href="javascript:;">{{khdetail.mobile_phone}}</a></span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>公司名称：</span>
                        <span v-if="khdetail.company_name">{{khdetail.company_name}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="khdetail.address">{{khdetail.address}}</span>
                        <span v-else>--</span>   
                    </div>
                    <div class="fieldItem">
                        <span>最近跟进时间：</span>
                        <span v-if="khdetail.last_follow_time">{{khdetail.last_follow_time}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>预计掉保时间：</span>
                        <span v-if="khdetail.deadline">{{khdetail.deadline}}</span>
                        <span v-else>--</span>
                    </div>
                </div>
                <div class="labelContainer">
                    <span class="title">标签展示：</span>
                    <div><span class="type-list" v-for="(item,idx) in khdetail.tag" :key="idx">{{item}}</span></div>
                    <div v-if="khdetail.tag.length>0">暂无</div>

                    <a-dropdown class="labelclue" v-model="typevisible">
                        <a class="ant-dropdown-link"  @click="e => e.preventDefault()"><a-icon type="edit" theme="filled"/> 编辑</a>
                        <div slot="overlay">
                            <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChange"
                            />

                            <div class="btnContent">
                                <a-button size="small" @click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div>
                    </a-dropdown>
                </div>

                <div class="btnListContainer" v-if="clueshow">
                    <a-button @click="showgj" type="primary"><a-icon type="snippets" theme="filled"/>写跟进</a-button>
                    <a-button @click="editkh" :id="khid"><a-icon type="edit" theme="filled"/>编辑</a-button>
                    <a-button @click="showplan"><a-icon type="clock-circle"/>创建计划</a-button>
                    <a-button @click="call(khdetail.mobile_phone)"><a-icon type="phone" theme="filled"/>拨打电话</a-button>
                    <a-button @click="addkhsj" :id="khid"><a-icon type="plus"/>新建商机</a-button>
                    <a-button @click="addkhlx" :id="khid"><a-icon type="plus"/>新建联系人</a-button>
                    <a-button @click="fqshow"><a-icon type="close-circle" theme="filled"/>放弃</a-button>
                    <a-button @click="showbg"><a-icon type="swap"/>变更所属人</a-button>
                    <a-button @click="delclue"><a-icon type="delete"/>删除</a-button>
                </div>

                <div class="btnListContainer" v-if="clueseashow">
                    <a-button ><a-icon type="export" />领取</a-button>
                    <a-button @click="showbg" ><a-icon type="share-alt"/>分配</a-button>
                    <a-button @click="delclue"><a-icon type="delete"/>删除</a-button>
                </div>
            </div>
            <div class="lowerInfoContent">
                <a-tabs default-active-key="1" >
                    <a-tab-pane key="1" tab="概况信息">
                        <div class="informationLeft">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>基本信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in khsystem_field_list" :key="i" :label="item.name">{{khdetail[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>

                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>相关联系人</span>
                                </div>
                                <a-table rowKey="id" bordered :columns="columns" :data-source="lxdata">
                                    <a slot="name" slot-scope="text">{{ text }}</a>
                                </a-table>

                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>相关商机</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in sjsystem_field_list" :key="i" :label="item.name">{{sjdetail[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                        </div>
                        <div class="informationRight">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>客户动态</span>
                                </div>

                                 <a-timeline v-if="gjrecord.length>0">
                                    <div v-for="(item,i) in gjrecord" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.date}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-title">{{followtilte}}</span>
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.add_time}}</span>
                                                    <div>{{item.content}}</div> 
                                                    <!-- <div><p>接通状态：已接听</p></div>
                                                    <div><p>通话对象：万先生</p></div>
                                                    <div class="RecordingAudio"></div> -->

                                                    <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div>
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>
                                    <!-- <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                    <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item> -->
                                </a-timeline>

                                <a-empty v-else :image="simpleImage" />
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="客户动态" force-render>
                        <div class="informationRight" style="padding-left:0;margin-left:0">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>客户动态</span>
                                </div>

                                <a-timeline v-if="gjrecord.length>0">
                                    <div  v-for="(item,i) in gjrecord" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.date}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-title">{{followtilte}}</span>
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.add_time}}</span>
                                                    <div>{{item.content}}</div> 
                                                    <!-- <div><p>接通状态：已接听</p></div>
                                                    <div><p>通话对象：万先生</p></div>
                                                    <div class="RecordingAudio"></div> -->

                                                    <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div>
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>
                                    <!-- <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                    <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item> -->
                                </a-timeline>

                                <a-empty v-else :image="simpleImage" />
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="资料详情">
                        <div class="informationLeft">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>基本信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in khsystem_field_list" :key="i" :label="item.name">{{khdetail[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>

                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>系统信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in khsystem_field_list2" :key="i" :label="item.name">{{khdetail[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                        </div>
                    </a-tab-pane>
                     <a-tab-pane key="4" tab="相关商机" force-render>
                        <div class="informationLeft">
                            <div class="basicinfo">
                                <a-table rowKey="id" bordered :columns="columns2" :data-source="sjdetail">
                                    <a slot="name" slot-scope="text">{{ text }}</a>
                                </a-table>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="5" :tab="text">
                         <div class="informationLeft">
                            <div class="basicinfo">
                                <a-table rowKey="id" bordered :columns="columns" :data-source="lxdata">
                                    <a slot="name" slot-scope="text">{{ text }}</a>
                                </a-table>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>

        <!-- 写跟进 -->
        <a-modal
        title="新建跟进"
        :visible="gjvisible"
        :confirm-loading="confirmLoading"
        @ok="gjhandleOk"
        @cancel="handleCancel"
        width="610px"
        okText="保存"
        >
            <div class="followLog">
               <a-textarea v-model="gjcontent" placeholder="勤跟进,多签单" :rows="2" />
            </div> 
        </a-modal>

         <!-- 变更所属人-->
        <a-modal
        title="变更所属人"
        :visible="bgvisible"
        :confirm-loading="confirmLoading"
        @ok="bghandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="保存"
        >
            <div class="bgLog">
                <a-row style="margin-bottom:20px">
                   <a-col :span="5" ><label for="">现有所属人：</label></a-col>
                   <a-col :span="16">
                        <span>程先生</span>
                   </a-col>
               </a-row>
                <a-row>
                   <a-col :span="5" ><label for="" class="required">指定所属人：</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="bghandleChange">
                            <a-select-option v-for="item in bglist" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>

                        </a-select>
                   </a-col>
               </a-row>
            </div> 
        </a-modal>

        
        <!-- 放弃 -->
        <a-modal
        title="放弃"
        :visible="fqvisible"
        :confirm-loading="confirmLoading"
        @ok="fqhandleOk"
        @cancel="handleCancel"
        width="520px"
        okText="确定"
        >
            <div class="fqLog">
               
               <a-row>
                   <a-col :span="5" ><label for="" class="required">放弃原因</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="fqreason">
                            <a-icon slot="suffixIcon" type="smile" />
                            <a-select-option v-for="(item,i) in reason" :key="i" :value="item">
                                {{item}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
               <div style="margin: 24px 46px 0px 92px;">
                   <span>*放弃到公海后此客户数据将属于公共资源，原归属人员不能再维护跟进和更新此客户数据。</span>
               </div>
            </div> 
        </a-modal>

        <!-- 创建计划 -->
        <a-modal
        title="创建计划"
        :visible="planvisible"
        :confirm-loading="confirmLoading"
        @ok="planhandleOk"
        @cancel="handleCancel"
        width="480px"
        okText="保存"
        >
            <div class="planLog">
                <a-row>
                    <a-col  style="text-align:right;margin:0 0 24px" :span="6">
                        <label class="required" for="">计划开始时间：</label>
                    </a-col>
                    <a-col :span="18">
                        <a-date-picker
                            format="YYYY-MM-DD"
                            :disabled-date="disabledDate"
                        />
                    </a-col>
                    </a-row>
                    <a-row>
                    <a-col style="text-align:right" :span="6">
                        <label class="required"  for="">计划内容：</label>
                    </a-col>
                    <a-col :span="18">
                        <a-textarea placeholder="请输入" :rows="5" />
                    </a-col>
                </a-row>
            </div>
        </a-modal>
    </div>
</template>
<style>
.ant-dropdown-content{
    width: 140px;
    padding: 10px 12px 4px;box-sizing: border-box
}
.ant-dropdown{background: #fff;box-shadow: 0 2px 8px rgba(0,0,0,.15);}
.ant-dropdown-content .ant-checkbox-group label{
    margin-bottom: 6px;
    display: block;
    margin-right: 0;
    font-size: 13px;
}
.btnContent{
    height: 36px;
    text-align: center;
    border-top: 1px solid #ededed;
    padding: 8px 10px 0px ;
}
.btnContent button{font-size:12px}
</style>

<script>
import { Modal } from 'ant-design-vue';
import moment from 'moment';
import { Empty } from 'ant-design-vue';
const columns = [
  {
    title: '联系人',
    dataIndex: 'contact_name',
    key: 'contact_name',
    scopedSlots: { customRender: 'contact_name' },
  },
  {
    title: '手机',
    dataIndex: 'mobile_phone',
    key: 'mobile_phone',
  },
  {
    title: '职务',
    dataIndex: 'role',
    key: 'role',
    ellipsis: true,
  },
];
const columns2 = [
  {
    title: '商机标题',
    dataIndex: 'niche_name',
    key: 'niche_name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '预计成交金额(¥)',
    dataIndex: 'transaction_amount',
    key: 'transaction_amount',
  },
  {
    title: '预计成交时间',
    dataIndex: 'expected_deal_date',
    key: 'expected_deal_date',
    ellipsis: true,
  },
   {
    title: '销售阶段',
    dataIndex: 'sales_stage',
    key: 'sales_stage',
  },
  {
    title: '阶段百分比',
    dataIndex: 'win_rate',
    key: 'win_rate',
  },
  {
    title: '意向产品',
    dataIndex: 'intentional_product',
    key: 'intentional_product',
    ellipsis: true,
  },
];
const data2 = [
  {
    key: '1',
    name: 'John Brown',
    age: 18759865674,
    address: 'New York No. 1 Lake Park, New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 18759865674,
    address: 'London No. 2 Lake Park, London No. 2 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 18759865674,
    address: 'Sidney No. 1 Lake Park, Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];
export default {
    data(){
        return{
            plainOptions:[],
            value: [],
            columns,
            columns2,
            data2,
            gjvisible:false,
            planvisible:false,
            fqvisible:false,
            bgvisible:false,
            confirmLoading:false,
            bglist:"",
            bgid:"",
            reason:"",
            cause_of_abandonment:"",
            gjcontent:"",
            khdetail:"",
            khsystem_field_list:"",
            sjsystem_field_list:"",
            khsystem_field_list2:"",
            sjdetail:"",
            lxdata:"",
            khid:"",
            clueshow:true,
            clueseashow:false,
            typevisible:false,
            type:1,

            menulist:"",
            userinfo:"",
            search:"",
            phone:"",
            callshow:false,
            cluedetail:"",
            plainOptions:[],
            tags:[],
            phoneid:"",
            typevisible:false,
            value: [],

            stepList:[
                {title:'全部'},
                {title:'跟进记录'},
                {title:'跟进行为'},
                {title:'操作日志'}
            ],
            gjrecord:"",
            text:'相关联系人'
        }
    },
    beforeCreate() {
        this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    },
    mounted(){
        this.khid=this.$route.query.id

        var cluetype=this.$route.query.type
        if(cluetype==1){
            this.type=2,
            this.clueshow=false,
            this.clueseashow=true
        }
        // 客户字段
        this.$axios.get('/api/kehufieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.khsystem_field_list=data2
            }else{
                this.$message.warning(res.data.msg);
            }
        }),
        this.$axios.get('/api/kehufieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:2
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.khsystem_field_list2=data2
            }else{
                this.$message.warning(res.data.msg);
            }
        }),
         // 商机字段
        this.$axios.get('/api/bussnessfieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.sjsystem_field_list=data2
                // for(var j in data2){
                //     this.labelname[data2[j].field_name]=""
                // }
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

        // 客户详情
        this.$axios.get("/api/getkehudetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:this.$route.query.id,
                datatype:this.type
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.khdetail=res.data.data.info
                this.sjdetail=res.data.data.bussness_info
                this.lxdata=res.data.data.contact_info
                this.text=this.text+'（'+res.data.data.contact_info.length+'）'
            }
        }),

        // 放弃原因
        this.$axios.get("/api/dropreason",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.reason=res.data.data
            }
        }),
         // 标签列表
        this.$axios.get("/api/getkehutags",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
        }).then((res)=>{
            if(res.data.code==200){
                this.plainOptions=res.data.data
            }else{
                this.$message.error(res.data.msg);
            }
        })
        this.getfollow()

    },
    methods:{
        addClass(index){
            this.current=index
            if(index==1){
                this.getfollow()
                this.followtilte="写跟进"
            }
        },
        getfollow(){
            this.$axios.get("/api/followlist",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    kehu_id:this.$route.query.id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjrecord=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },



        moment,

        
        totel(){

        },
         // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChangetype(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.get("/api/setdatatags",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    data_id:this.phoneid,
                    tag:this.tags
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                    this.$axios.get("/api/getdatatags",{
                        headers: {
                            "appid": this.appSet.appid,
                            "appkey": this.appSet.appkey,
                            "token":localStorage.getItem('token'),
                        },
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.plainOptions=res.data.data
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        //处理按键
        handleKeyPress(e) {
            let num = e.target.dataset.num;
            this.phone=this.phone+num
        },
        call(value){
            this.phoneid=value
            var id=this.$route.query.id
            this.callshow=!this.callshow,
            this.phone=value
            wsinit()
            callfixed(id,1)
            this.show4='none'
            this.show1='none'
            this.show3='none'
            this.show2='block'

            this.$axios.get("/api/getdatadetail",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:id,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data.info
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },
        total(){

        },
        
        closecall(){
            this.callshow=false
        },


        // 设置标签
        handleMenuClick(){
            this.typevisible=false
        },
        onChange(checkedValues) {
            this.tags=checkedValues
        },
        settag(){
            this.$axios.post("/api/setkehutags",{
                    data_id:this.$route.query.id,
                    tag:this.tags
                },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg);
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        getdetail(value){
            this.$axios.get("/api/getkehudetail",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:this.khdetail.id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.khdetail=res.data.data.info
                    this.sjdetail=res.data.data.bussness_info
                    this.lxdata=res.data.data.contact_info
                    this.text=this.text+'（'+res.data.data.contact_info.length+'）'
                }
            })
        },

        // 上一个
        prev(){
            var value='prev'
            this.getdetail(value)
        },
        // 下一个
        next(){
            var value='next'
            this.getdetail(value)
        },

        addkhlx(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/addkhlx',query:{ id:id}});
        },
        addkhsj(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/addkhsj',query:{ id:id}});
        },
         // 编辑
        editkh(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/editcustom',query:{ id:id}});
        },

        disabledDate(current) {
            return current < moment().endOf('day');
        },
        bghandleChange(value){
            this.bgid=value
        },

        back(){
            this.$router.go(-1);//返回上一层
        },
        showgj(){
            this.gjvisible=true
        },
        showbg(){
            this.bgvisible=true
        },
        showplan(){
            this.planvisible=true
        },
        fqshow(){
            this.fqvisible=true
        },
        handleCancel(){
            this.gjvisible=false
            this.planvisible=false
            this.fqvisible=false
            this.bgvisible=false
        },
        // 跟进
        gjhandleOk(){
            this.$axios.get("/api/addfollow",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    content:this.gjcontent,
                    kehu_id:this.$route.query.id,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjvisible=false
                    this.$message.success(res.data.msg); 
                    this.getfollow()

                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 计划
        planhandleOk(){

        },
        // 变更
        bghandleOk(){
            this.$axios.get("/api/setdatabelong",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:this.$route.query.id,
                    user_id:this.bgid
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 放弃
        fqreason(value){
            this.cause_of_abandonment=value
        },
        fqhandleOk(){
            this.$axios.get("/api/dropdata",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:this.$route.query.id,
                    cause_of_abandonment:this.cause_of_abandonment
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        change(){

        },
        // 删除
        delclue() {
            Modal.confirm({
                title: '提示',
                content: '您确定删除此菜单吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok()
                },
                onCancel() {

                },
            });
        },

        handok(){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delmenu',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
     
            })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/customer/customdetail.vue